import type { UtilityContextWithTracker } from '#src/app/shared/contexts/asyncData';

import type {
	PsfSocialStarterEligibilityQuery,
	PsfSocialStarterEligibilityQueryVariables,
} from './socialStarterEligibility.graphql';
import { PsfSocialStarterEligibility } from './socialStarterEligibility.graphql';

export type SocialStarterEligibility = {
	eligible: boolean;
	slug: string;
};

/**
 * Resolves Social Starter first-step eligibility in a single middle-end request. Fails open: any
 * request error is reported as a warning and treated as ineligible.
 */
export async function fetchSocialStarterEligibility(
	utilityContext: UtilityContextWithTracker,
	slug: string,
): Promise<SocialStarterEligibility> {
	try {
		const { data } = await utilityContext.gql.fetch<
			PsfSocialStarterEligibilityQuery,
			PsfSocialStarterEligibilityQueryVariables
		>({
			query: PsfSocialStarterEligibility,
			variables: { slugOrId: slug },
			rejectOnError: true,
		});

		const { eligible, slug: canonicalSlug } = data.psfSocialStarterFirstStepEligibility;
		return { eligible, slug: canonicalSlug ?? slug };
	} catch (error) {
		void utilityContext.errorReporter.report(
			{
				error: error instanceof Error ? error : String(error),
				context: { feature: 'psf_social_starter_first_step_eligibility' },
			},
			{ severity: 'warning' },
		);
		return { eligible: false, slug };
	}
}
